import React, { ReactNode } from 'react';
import { ToggleWrapper } from './ToggleWrapper';
import { ToggledFeature } from './featureToggleService';

export function BusinessDaysToggleWrapper(
  props: {
    children: ReactNode,
  }
) {
  return (
    <ToggleWrapper feature={ToggledFeature.BUSINESS_DAYS}>
      {props.children}
    </ToggleWrapper>
  );
}
